import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import { isMobile } from '@/utils/util'
import footer from './modules/footer'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isMobile: isMobile(),
  },
  modules: {
    footer
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js